import React, { ReactNode } from 'react';
import './index.scss';
import ControlBtn from './ControlBtn';
import { clstagStr } from '@/views/MapEditor/utils';
import { CLSTAG } from '@/utils/constant';

const Drawer = ({
  className,
  isOpen,
  children,
  openBtn,
  closeBtn,
  openWidth,
  closeWidth,
  showEditForm,
  forceOpen,
  onOpenChange,
}: {
  className?: string;
  isOpen: boolean;
  children: ReactNode;
  openBtn?: ReactNode;
  closeBtn?: ReactNode;
  openWidth: string;
  closeWidth?: string;
  showEditForm: boolean;
  forceOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
}) => {
  const isForcedOpen = showEditForm || forceOpen;
  const renderedOpen = isForcedOpen ? true : isOpen;
  const drawerWidth = renderedOpen ? openWidth : closeWidth ?? '0px';

  return (
    <div
      className={`map-editor-drawer-container ${renderedOpen ? 'map-editor-drawer-open' : 'map-editor-drawer-closed'} ${
        isForcedOpen ? 'map-editor-drawer-forced-open' : ''
      } ${className ?? ''}`}
      style={{ width: drawerWidth }}
    >
      {openBtn && !renderedOpen && !isForcedOpen && (
        <div
          className="open-btn"
          onClick={() => onOpenChange?.(true)}
          clstag={clstagStr(CLSTAG.OpenFoldRightDrawer)}
        >
          {openBtn}
        </div>
      )}
      {closeBtn && renderedOpen && !isForcedOpen && (
        <div
          className="close-btn"
          onClick={() => onOpenChange?.(false)}
          clstag={clstagStr(CLSTAG.OpenFoldRightDrawer)}
        >
          {closeBtn}
        </div>
      )}
      <div className="map-editor-drawer-content">{children}</div>
    </div>
  );
};
export const ControlBtnNode = ControlBtn;

export default React.memo(Drawer);
